// Salon-wide gift-card selling channels — a master override that sits on top
// of each voucher's own online/pos flags. When a channel is off here, that
// channel is hidden for ALL vouchers (the shop, the salon page, the POS),
// regardless of per-voucher settings. The per-voucher flags are never changed,
// so flipping a channel back on restores exactly what was set before.
//
// MOCK store (localStorage) so the admin toggle and the customer-facing shop
// gate are demoable in a single browser.
//
// TODO(backend): persist this on the salon record (e.g. `salon.giftCardChannels
// = { online, pos }`) AND return it in the PUBLIC salon summary, so the shop
// (useGiftCardShopData) and the salon page read the real value rather than this
// localStorage stand-in.
const KEY = 'beu_gc_channels';
const DEFAULT = { online: true, pos: true };

export const getGiftCardChannels = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) {
      const v = JSON.parse(raw);
      return { online: v.online !== false, pos: v.pos !== false };
    }
  } catch (e) { /* ignore malformed / blocked storage */ }
  return { ...DEFAULT };
};

export const setGiftCardChannels = (channels) => {
  const next = { online: channels.online !== false, pos: channels.pos !== false };
  try { localStorage.setItem(KEY, JSON.stringify(next)); } catch (e) { /* ignore */ }
  return next;
};
